/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

document.querySelectorAll('.predictive-search-input').forEach((input) => {
    input.addEventListener('input', window.debounce((e) => {
        const form = e.target.closest('form')
        const value = e.target.value
        const dropdown = form.querySelector('.predictive-search-dropdown')
        const inputIcon = form.querySelector('.input-group-text')

        if (value.length === 0) {
            dropdown.classList.remove('show')
            input.setAttribute('aria-expanded', 'false')
            document.querySelector('.modal-backdrop')?.remove()
            document.body.classList.remove('is-searching')
        } else {
            inputIcon.querySelector('.predictive-search-icon-search').style.display = 'none'
            inputIcon.querySelector('.predictive-search-icon-loading').style.display = 'flex'

            const {
                limitResults,
                imgWidth,
                imgHeight,
                imgBorder,
                btnColor,
                textOldPrice,
                textPriceFrom,
                textViewAllResults,
                textTitleCollections,
                textTitleProducts
            } = dropdown.dataset

            const url = `/search/suggest.json?q=${value}&resources[type]=product,collection&resources[limit]=${limitResults}&resources[options][unavailable_products]=last`

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    console.log(data)
                    const { collections, products } = data.resources.results

                    inputIcon.querySelector('.predictive-search-icon-search').style.display = 'block'
                    inputIcon.querySelector('.predictive-search-icon-loading').style.display = 'none'

                    if (products.length || collections.length) {
                        let collectionListItems = ''
                        let productListItems = ''

                        collections.forEach((collection) => {
                            collectionListItems += `
                                <li class="p-2">
                                    <a 
                                        href="${collection.url}" 
                                        class="btn btn-outline-dark btn-sm py-1">
                                        ${collection.title}
                                    </a>
                                </li>
                            `
                        })

                        products.forEach((product) => {
                            productListItems += `
                                <li class="product-list-item px-4">
                                    <a href="${product.url}" class="text-decoration-none text-dark d-block">
                                        <div class="d-flex align-items-center py-2">
                                            <img 
                                                class="product-img img-fluid me-4 ${imgBorder}"
                                                src="${window.resizeImage(product.featured_image.url || 'no-image.gif', `${imgWidth}x${imgHeight}`, 'center')}"
                                                alt="${product.featured_image.alt}" 
                                                width="${imgWidth}"
                                                height="${imgHeight}"
                                                loading="lazy">
                                            <div>
                                                <h5 class="product-title h6 small mb-1">
                                                    ${product.title}
                                                </h5>
                                                <p class="product-price mb-1">
                                                    <s class="product-price-compare text-muted me-1 ${product.compare_at_price_min > product.price ? '' : 'd-none'}">
                                                        <span class="visually-hidden">
                                                            ${textOldPrice}
                                                        </span>
                                                        ${window.formatMoney(product.compare_at_price_min)}
                                                    </s>
                                                    <span class="product-price-final">
                                                        <span class="product-price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                                            ${textPriceFrom}
                                                        </span>
                                                        ${window.formatMoney(product.price)}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            `
                        })
                        dropdown.innerHTML = `
                            <div class="predictive-search-collection-list ${collections.length ? '' : 'd-none'}">
                                <h4 class="title h6 small text-uppercase mt-3 mb-3 mx-4">
                                    ${textTitleCollections}
                                </h4>
                                <ul class="collection-list list-unstyled d-flex flex-wrap mx-3 mt-2 mb-6">
                                    ${collectionListItems}
                                </ul>
                            </div>
                            <div class="predictive-search-product-list ${products.length ? '' : 'd-none'}">
                                <h4 class="title h6 small text-uppercase mt-3 mb-3 mx-4">
                                    ${textTitleProducts}
                                </h4>
                                <ul class="product-list list-unstyled mt-2 mb-4">
                                    ${productListItems}
                                </ul>
                            </div>
                            <hr class="mt-0">
                            <div class="px-4 pb-2">
                                <button type="submit" class="btn btn-sm w-100 ${btnColor}">
                                    ${textViewAllResults}
                                </button>
                            </div>
                        `
                        dropdown.classList.add('show')
                        input.setAttribute('aria-expanded', 'true')

                        if (!document.querySelector('.modal-backdrop')) {
                            document.body.insertAdjacentHTML(
                                'beforeend', '<div id="search-modal-backdrop" class="modal-backdrop fade" onclick="closeSearchResults()"></div>'
                            )
                            setTimeout(() => {
                                document.querySelector('#search-modal-backdrop').classList.add('show')
                            }, 200)
                            document.body.classList.add('is-searching')
                        }
                    } else {
                        dropdown.classList.remove('show')
                        input.setAttribute('aria-expanded', 'false')
                    }
                })
        }
    }))
})

// Close search results
// Happens when clicked the backdrop area
// eslint-disable-next-line no-unused-vars
window.closeSearchResults = () => {
    document.querySelectorAll('.predictive-search-input').forEach((input) => {
        const form = input.closest('form')
        const dropdown = form.querySelector('.predictive-search-dropdown')
        dropdown.classList.remove('show')
        input.setAttribute('aria-expanded', 'false')
        input.value = ''
        document.querySelector('.modal-backdrop')?.remove()
        document.body.classList.remove('is-searching')
    })
}
